module.exports = __webpack_public_path__ + "media/images/Ellipse-5adc11ae543c6ff35684a4f3073391c1.png";